// extracted by mini-css-extract-plugin
export default {"inputRatio":"StarsRating_inputRatio__SBcfW","star":"StarsRating_star__biBXs","starsContainer":"StarsRating_starsContainer__XSHjk"};